// 是否是分销订单
export function isFxTrade(data) {
  return data.convertType === 1 && [1, 3].includes(data.belongType);
}

// 是否是供销订单
export function isGxTrade(data) {
  return data.convertType === 1 && [2, 3].includes(data.belongType);
}

// 是否是供销且分销订单
export function isGxAndFxTrade(data) {
  return data.convertType === 1 && data.belongType === 3;
}

// 是否是分销订单（不包含 供销且分销）
export function isPureFxTrade(data) {
  return data.belongType == 1;
}

// 是否是供销订单（不包含 供销且分销）
export function isPureGxTrade(data) {
  return data.source === 'newfx' || data.ifQimenFxSource
}

// 是否是跨境订单
export function isCrossOrderNew(tradeData) {
  return tradeData.source === 'shopee' || tradeData.shopSource === 'shopee';
}

// 是否是BIC订单
export function isBICOrder(tradeData) {
  return (tradeData.shopSource === 'fxg' || tradeData.source === 'fxg') && tradeData.subSource === 'BIC';
}

// 是否是放心购代发订单
export function isFxgDf(tradeData) {
  return tradeData.source === 'fxg_df'
}

// 奇门订单
export function isQiMenOrder(tradeData) {
  return tradeData.source === 'qimen'
}

// 是否是奇门供销+订单
export function isQiMenGx(tradeData) {
  return (tradeData.convertType == 3 && tradeData.belongType == 2) || !!tradeData.ifQimenFxSource;
}


// 是否为国际站线下物流
export function isIntlStationOfflineLogistics(tradeData) {
  // 是否为国际站订单
  const isIntlStation = isAlibabaIcbu(tradeData);
  return isIntlStation && tradeData.expressTemplateName?.includes('线下物流');
}

// 是否是阿里巴巴国际站订单
export function isAlibabaIcbu(tradeData) {
  return tradeData.shopSource === 'alibaba_icbu';
}


export default {
  isFxTrade,
  isGxTrade,
  isGxAndFxTrade,
  isPureFxTrade,
  isCrossOrderNew,
  isBICOrder,
  isFxgDf,
  isQiMenOrder,
  isQiMenGx,
  isIntlStationOfflineLogistics,
}